import "./Homepage.module.css";
import Header from "@/reusable_sections/Header";
import PromotionalCarouselBanner from "./sections/PromotionalCarouselBanner";
import CaseStudiesShowcaseGrid from "./sections/CaseStudiesShowcaseGrid";
import KeyStatisticsSection from "./sections/KeyStatisticsSection";
import OurServicesApproachGrid from "./sections/OurServicesApproachGrid";
import AtmosphereCultureCarousel from "./sections/AtmosphereCultureCarousel";
import Footer from "@/reusable_sections/Footer";
import Twobuttoncta from "./sections/Twobuttoncta";
import Twobuttoncalltoaction from "./sections/Twobuttoncalltoaction";
export default function HomepagePage() {
  return <div>
      <Header />
      <PromotionalCarouselBanner />
      <Twobuttoncalltoaction />
      <Twobuttoncta />
      <CaseStudiesShowcaseGrid />
      <KeyStatisticsSection />
      <OurServicesApproachGrid />
      <AtmosphereCultureCarousel />
      <Footer />
    </div>;
}